import React, { Component } from 'react';
import { connect } from 'react-redux'
import * as Actions from './redux-actions.js'
import request from 'request'
import { DisappearedLoading } from 'react-loadingg';
import { withRouter } from "react-router-dom";
import { HashLink as Link } from 'react-router-hash-link';

//import { Link, Route } from 'react-router-dom'
import * as globals from './globals.js'
import * as helpers from './helpers.js'

import CarList from './CarList.jsx'
import ContactBanner from './ContactBanner.jsx'

import './ModernHome.css'


class MainPage extends Component {
  constructor(props) {
    super(props);

  }


  render() {

    //window.scrollTo(0, 0);

    let content

    if (typeof this.props.reduxDictionary === 'undefined') {
      return (<div><DisappearedLoading color="#000000" size="large" /></div>)
    }

    let messages

    if (this.props.reduxDictionary.messages.length > 0) {

      messages = this.props.reduxDictionary.messages.map((msg, idx) => {
        return (
          <div key={idx} className={(msg.severity === "INFO") ? "notification is-info" : "notification is-danger"}
            dangerouslySetInnerHTML={{ __html: msg.message }}>
          </div>
        )

      })

    }

    return (
      <div className="modern-home">

        {/* Hero Section - Modern Design */}
        <section className="hero is-fullheight modern-hero">
          <div className="hero-body">
            <div className="container">
              <div className="columns is-vcentered">
                <div className="column is-6">
                  <div className="hero-content">
                    <h1 className="modern-title">
                      Affordable Transfer Services in <span className="highlight">Azerbaijan</span> & <span className="highlight">Turkey</span>
                    </h1>
                    <p className="modern-subtitle">
                      Family-owned and operated. Reliable, comfortable transportation at honest prices. Available 24/7 for your convenience.
                    </p>
                    <div className="hero-buttons">
                      <Link to="/#services" className="button is-primary is-large modern-btn">
                        <span className="icon">
                          <i className="fas fa-car"></i>
                        </span>
                        <span>Book Now</span>
                      </Link>
                      <a href="tel:+994502284849" className="button is-light is-large modern-btn-outline" onClick={() => window.gtag_report_conversion && window.gtag_report_conversion(undefined, 'phone_' + Date.now())}>
                        <span className="icon">
                          <i className="fas fa-phone"></i>
                        </span>
                        <span>+994 50 228 48 49</span>
                      </a>
                    </div>

                    {/* TripAdvisor Award Badge */}
                    <div className="hero-tripadvisor-badge">
                      <div className="tripadvisor-badge-container">
                        <img src="https://aztur-global.s3.eu-central-1.amazonaws.com/tchotel_2025_L.png" alt="TripAdvisor Travellers' Choice 2025" className="tripadvisor-badge-image" />
                        <div className="tripadvisor-badge-text">
                          <div className="badge-title">Travellers' Choice™ 2025</div>
                          <div className="badge-description">Top 10% Worldwide</div>
                        </div>
                      </div>
                    </div>

                    {/* Trust Indicators */}
                    <div className="trust-indicators">
                      <div className="trust-item">
                        <div className="trust-icon">
                          <i className="fas fa-clock"></i>
                        </div>
                        <div className="trust-text">
                          <strong>24/7 Service</strong>
                          <span>Always Available</span>
                        </div>
                      </div>
                      <div className="trust-item">
                        <div className="trust-icon">
                          <i className="fas fa-star"></i>
                        </div>
                        <div className="trust-text">
                          <strong>Top Rated</strong>
                          <span>5-Star Reviews</span>
                        </div>
                      </div>
                      <div className="trust-item">
                        <div className="trust-icon">
                          <i className="fas fa-crown"></i>
                        </div>
                        <div className="trust-text">
                          <strong>CIP/VIP Service</strong>
                          <span>GYD Airport</span>
                        </div>
                      </div>
                      <div className="trust-item">
                        <div className="trust-icon">
                          <i className="fas fa-briefcase"></i>
                        </div>
                        <div className="trust-text">
                          <strong>Corporate Service</strong>
                          <span>For Organizations</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="column is-6">
                  <div className="hero-image-container">
                    <div className="floating-card">
                      <img src="https://aztur-global.s3.eu-central-1.amazonaws.com/hero_image.jpg" alt="Azerbaijan Transfer" className="hero-image" />
                      <div className="floating-badge">
                        <i className="fas fa-check-circle"></i>
                        <span>Verified Service</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Scroll Indicator 
  <div className="scroll-indicator">
    <div className="mouse"></div>
  </div>*/}
        </section>

        {/* Turkey Announcement Section */}
        <section className="section" style={{padding: "3rem 1.5rem", background: "linear-gradient(135deg, #fff8e1 0%, #ffe082 100%)"}}>
          <div className="container">
            <div className="columns is-vcentered">
              <div className="column is-2 has-text-centered">
                <i className="fas fa-globe-europe" style={{fontSize: "5rem", color: "#e30613"}}></i>
              </div>
              <div className="column is-8">
                <h2 style={{fontSize: "2.5rem", fontWeight: "700", color: "#e30613", marginBottom: "1rem"}}>
                  Now Serving Turkey!
                </h2>
                <p style={{fontSize: "1.25rem", color: "#f57c00", marginBottom: "1.5rem"}}>
                  We're excited to announce our expansion to Turkey! Professional transportation services now available in Istanbul and beyond.
                </p>
              </div>
              <div className="column is-2 has-text-centered">
                <Link to="/turkey" className="button is-danger is-large">
                  <span>Learn More</span>
                  <span className="icon"><i className="fas fa-arrow-right"></i></span>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Partnership Section */}
        <section className="section partnership-section">
          <div className="container">
            <div className="has-text-centered partnership-header">
              <h2 className="section-title">Az-Tur: Trusted Transportation Partner</h2>
              <p className="section-subtitle">
                Proud to have served major international events in Azerbaijan and Turkey
              </p>
            </div>

            <div className="partnership-content">
              <div className="columns is-vcentered is-multiline">
                <div className="column is-4">
                  <div className="partnership-card">
                    <div className="partnership-logo">
                      <img src="https://aztur-global.s3.eu-central-1.amazonaws.com/COP29_logo.png" alt="COP29 Azerbaijan" />
                    </div>
                    <div className="partnership-info">
                      <h3 className="partnership-title">COP29 Azerbaijan</h3>
                      <p className="partnership-description">Official transportation partner for the UN Climate Change Conference</p>
                    </div>
                  </div>
                </div>

                <div className="column is-4">
                  <div className="partnership-card">
                    <div className="partnership-logo">
                      <img src="https://aztur-global.s3.eu-central-1.amazonaws.com/f1_logo.png" alt="Formula 1" />
                    </div>
                    <div className="partnership-info">
                      <h3 className="partnership-title">Formula 1</h3>
                      <p className="partnership-description">Trusted transportation partner for F1 events in Baku</p>
                    </div>
                  </div>
                </div>

                <div className="column is-4">
                  <div className="partnership-card">
                    <div className="partnership-logo">
                      <img src="https://aztur-global.s3.eu-central-1.amazonaws.com/ufc_logo.png" alt="UFC" />
                    </div>
                    <div className="partnership-info">
                      <h3 className="partnership-title">UFC</h3>
                      <p className="partnership-description">Official transportation partner for UFC events in Azerbaijan</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="has-text-centered partnership-cta">
              <p className="partnership-cta-text">
                Need transportation services for your event or business?
              </p>
              <Link to="/contact" className="button is-primary is-medium partnership-cta-btn">
                <span className="icon">
                  <i className="fas fa-envelope"></i>
                </span>
                <span>Contact Us for Custom Solutions</span>
              </Link>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="section modern-features">
          <div className="container">
            <div className="has-text-centered main-features-header">
              <h2 className="section-title">Why Choose Az-Tur?</h2>
              <p className="section-subtitle">
                Your trusted partner for comfortable and reliable transportation
              </p>
            </div>

            <div className="columns is-multiline">
              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-dollar-sign"></i>
                  </div>
                  <h3 className="feature-title">Best Prices</h3>
                  <p className="feature-description">
                    Transparent pricing with no hidden fees. What you see is what you pay.
                  </p>
                </div>
              </div>

              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-user-tie"></i>
                  </div>
                  <h3 className="feature-title">Professional Drivers</h3>
                  <p className="feature-description">
                    Experienced, licensed drivers who know every corner of Azerbaijan.
                  </p>
                </div>
              </div>

              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-car-side"></i>
                  </div>
                  <h3 className="feature-title">Modern Fleet</h3>
                  <p className="feature-description">
                    Well-maintained, comfortable vehicles for all your travel needs.
                  </p>
                </div>
              </div>

              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-headset"></i>
                  </div>
                  <h3 className="feature-title">24/7 Support</h3>
                  <p className="feature-description">
                    Round-the-clock customer service for your peace of mind.
                  </p>
                </div>
              </div>

              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-map-marked-alt"></i>
                  </div>
                  <h3 className="feature-title">Local Expertise</h3>
                  <p className="feature-description">
                    Deep knowledge of routes, attractions, and hidden gems.
                  </p>
                </div>
              </div>

              <div className="column is-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-mobile-alt"></i>
                  </div>
                  <h3 className="feature-title">Easy Booking</h3>
                  <p className="feature-description">
                    Simple online booking process with instant confirmation.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Fleet Section */}
        <a className="anchor" id="services"></a>
        <section className="section modern-services">
          <div className="container">
            {messages}

            <div className="has-text-centered mb-6">
              <h2 className="section-title">Our Fixed-Price Offers</h2>
              <div className="fleet-pricing-info">
                <div className="pricing-info-box">
                  <i className="fas fa-info-circle"></i>
                  <span>Prices shown are for Heydar Aliyev Airport (GYD) to/from Baku. Click "Choose Destination & Book" to select your destination and get an instant price quote.</span>
                </div>
              </div>
              <p className="fleet-contact-note">
                For custom tours or special enquiries, <a href="https://wa.me/994502284849" className="fleet-contact-link" target="_blank" rel="noopener noreferrer" onClick={() => window.gtag_report_conversion && window.gtag_report_conversion(undefined, 'whatsapp_' + Date.now())}><i className="fab fa-whatsapp"></i> WhatsApp us</a> for personalized solutions
              </p>
            </div>

            <div className="car-list-modern">
              <CarList />
            </div>
          </div>
        </section>

        {/* Our Services Section */}
        <a className="anchor" id="our-services"></a>
        <section className="section modern-our-services">
          <div className="container">
            <div className="has-text-centered mb-6">
              <h2 className="section-title">Our Services</h2>
              <p className="section-subtitle">
                Comprehensive transportation and tourism solutions
              </p>
            </div>

            <div className="columns is-multiline">
              <div className="column is-one-fifth">
                <div className="service-item">
                  <div className="service-icon">
                    <i className="fas fa-plane-arrival"></i>
                  </div>
                  <h3 className="service-title" dangerouslySetInnerHTML={{ __html: helpers.cnt('srvc_t_1') }}></h3>
                  <div className="service-description" dangerouslySetInnerHTML={{ __html: helpers.cnt('srvc_t_1_b') }}></div>
                </div>
              </div>

              <div className="column is-one-fifth">
                <div className="service-item">
                  <div className="service-icon">
                    <i className="fas fa-map-marked-alt"></i>
                  </div>
                  <h3 className="service-title" dangerouslySetInnerHTML={{ __html: helpers.cnt('srvc_t_5') }}></h3>
                  <div className="service-description" dangerouslySetInnerHTML={{ __html: helpers.cnt('srvc_t_5_b') }}></div>
                </div>
              </div>

              <div className="column is-one-fifth">
                <div className="service-item">
                  <div className="service-icon">
                    <i className="fas fa-route"></i>
                  </div>
                  <h3 className="service-title" dangerouslySetInnerHTML={{ __html: helpers.cnt('srvc_t_2') }}></h3>
                  <div className="service-description" dangerouslySetInnerHTML={{ __html: helpers.cnt('srvc_t_2_b') }}></div>
                </div>
              </div>

              <div className="column is-one-fifth">
                <div className="service-item">
                  <div className="service-icon">
                    <i className="fas fa-building"></i>
                  </div>
                  <h3 className="service-title" dangerouslySetInnerHTML={{ __html: helpers.cnt('srvc_t_3') }}></h3>
                  <div className="service-description" dangerouslySetInnerHTML={{ __html: helpers.cnt('srvc_t_3_b') }}></div>
                </div>
              </div>

              <div className="column is-one-fifth">
                <div className="service-item">
                  <div className="service-icon">
                    <i className="fas fa-users"></i>
                  </div>
                  <h3 className="service-title" dangerouslySetInnerHTML={{ __html: helpers.cnt('srvc_t_4') }}></h3>
                  <div className="service-description" dangerouslySetInnerHTML={{ __html: helpers.cnt('srvc_t_4_b') }}></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* TripAdvisor Award Section */}
        <section className="section tripadvisor-award-section">
          <div className="container">
            <div className="columns is-vcentered">
              <div className="column is-4 has-text-centered">
                <div className="award-image-container">
                  <img src="https://aztur-global.s3.eu-central-1.amazonaws.com/tchotel_2025_L.png" alt="TripAdvisor Travellers' Choice 2025" className="award-image" />
                </div>
              </div>
              <div className="column is-8">
                <div className="award-content">
                  <h2 className="award-title">Tripadvisor Travellers' Choice™ Awards 2025</h2>
                  <p className="award-description">
                    Reviews from millions of Tripadvisor travellers place us in the top 10% worldwide.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* About Section */}
        <a className="anchor" id="about"></a>
        <section className="section modern-about">
          <div className="container">
            <div className="columns is-vcentered">
              <div className="column is-6">
                <div className="about-image-wrapper">
                  <img src="https://aztur-global.s3.eu-central-1.amazonaws.com/landscape.jpg" alt="About Az-Tur" className="about-image" />
                  <div className="about-badge">
                    <div className="badge-content">
                      <span className="badge-number">10+</span>
                      <span className="badge-text">Years Experience</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="column is-6">
                <div className="about-content">
                  <h2 className="section-title">About Az-Tur</h2>
                  <div className="about-slogan">
                    <i className="fas fa-quote-left"></i>
                    <span>A Family's Zeal for Travel, Uniquely Refined</span>
                    <i className="fas fa-quote-right"></i>
                  </div>
                  <p className="about-text">
                    We are a local company dedicated to providing exceptional transfer and tourism services throughout Azerbaijan. With years of experience and a commitment to excellence, we ensure every journey is comfortable, safe, and memorable.
                  </p>

                  <div className="about-stats">
                    <div className="stat-item">
                      <div className="stat-number">5000+</div>
                      <div className="stat-label">Happy Customers</div>
                    </div>
                    <div className="stat-item">
                      <div className="stat-number">24/7</div>
                      <div className="stat-label">Available</div>
                    </div>
                    <div className="stat-item">
                      <div className="stat-number">100%</div>
                      <div className="stat-label">Satisfaction</div>
                    </div>
                  </div>

                  <div className="about-highlights">
                    <div className="highlight-item">
                      <i className="fas fa-check-circle"></i>
                      <span>Punctual and reliable service</span>
                    </div>
                    <div className="highlight-item">
                      <i className="fas fa-check-circle"></i>
                      <span>Experienced local drivers</span>
                    </div>
                    <div className="highlight-item">
                      <i className="fas fa-check-circle"></i>
                      <span>Competitive pricing</span>
                    </div>
                    <div className="highlight-item">
                      <i className="fas fa-check-circle"></i>
                      <span>Clean and comfortable vehicles</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="section modern-cta">
          <div className="container">
            <div className="cta-box">
              <h2 className="cta-title">Ready to Book Your Transfer?</h2>
              <p className="cta-subtitle">Get started now and experience the best transportation service in Azerbaijan</p>
              <div className="cta-buttons">
                <Link to="/atform" className="button is-white is-large">
                  <span className="icon">
                    <i className="fas fa-calendar-check"></i>
                  </span>
                  <span>Book Online</span>
                </Link>
                <a href="https://wa.me/994502284849" className="button is-success is-large" onClick={() => window.gtag_report_conversion && window.gtag_report_conversion(undefined, 'whatsapp_' + Date.now())}>
                  <span className="icon">
                    <i className="fab fa-whatsapp"></i>
                  </span>
                  <span>WhatsApp Us</span>
                </a>
              </div>
            </div>
          </div>
        </section>



      </div>
    )

  }
}


const mapStateToProps$MainPage = function (state) {
  return { reduxDictionary: state.dictionary }
}

const mapDispatchToProps$MainPage = function (dispatch) {
  return {
    setValidity: function (valid) { dispatch(Actions.actionSetValidity(valid)) }
  }
}

export default withRouter(connect(mapStateToProps$MainPage, mapDispatchToProps$MainPage)(MainPage))



